var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ivu-login"},[_c('Form',{ref:"form",attrs:{"model":_vm.formValidate},nativeOn:{"submit":function($event){$event.preventDefault();}}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/login/login.vue